import { Button } from "@/components/ui/button";
import { useKycLogout } from "./use-kyc-logout";
import { toSentenceCase } from "@/lib/utils";

const KycRejected = ({
  reviewNote,
  onResubmit,
}: {
  reviewNote?: string | null;
  onResubmit: () => void;
}) => {
  const logout = useKycLogout();

  return (
    <div className="mx-auto mt-6 flex w-full max-w-xl grow flex-col justify-center text-center lg:mt-0">
      <img
        src="/images/kyc-rejected.svg"
        alt=""
        className="mx-auto size-28 lg:size-36"
      />
      <h1 className="mt-6 text-2xl font-semibold lg:text-3xl">
        Verification not approved
      </h1>
      <p className="mx-auto mt-3 max-w-md text-sm lg:text-base">
        We couldn&apos;t verify your identity with the details you submitted.
        Please review the note below and submit again.
      </p>

      <div className="border-primary-red/30 bg-primary-red/5 mt-8 rounded-md border p-4 text-left">
        <h2 className="font-semibold">Reason from our team</h2>
        <p className="mt-1 text-sm">
          {reviewNote
            ? toSentenceCase(reviewNote)
            : "No reason was given. Please check your details."}
        </p>
        <p className="text-auth-muted mt-3 text-xs">
          Your previous details are saved. You only need to fix what was wrong
          and upload your documents again.
        </p>
      </div>

      <Button
        onClick={onResubmit}
        className="bg-auth-action text-auth-on-action hover:bg-auth-action/90 mt-8 h-11 w-full rounded"
      >
        Resubmit verification
      </Button>
      <Button
        variant="outline"
        onClick={logout}
        className="border-auth-action text-auth-text mt-3 h-11 w-full rounded bg-transparent"
      >
        Logout
      </Button>
    </div>
  );
};

export default KycRejected;
